import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { errorMessage } from 'src/app/core/utils/error-handler.utils';
import { showMatSnackMessage } from 'src/app/core/utils/message-handler.util';
import { conceptosDto } from 'src/app/models/carga-fc.dto';
import { ProvinciasDto } from 'src/app/models/provincias.dto';
import { ProvinciasService } from 'src/app/services/provincias.service';
@Component({
  selector: 'app-totales-facturas-proveedor',
  templateUrl: './totales-facturas-proveedor.component.html',
  styleUrls: ['./totales-facturas-proveedor.component.scss']
})
export class TotalesFacturasProveedorComponent {

  @Input() set datosFacturas(value: any) {
    if (value) {
      // Aseguramos estructuras internas para evitar errores
      this._datosFacturas = {
        formulario: {
          totales: {},
          ...value.formulario
        },
        ...value
      };
    }
  }

  get datosFacturas() {
    return this._datosFacturas;
  }

  private _datosFacturas: any = {
    formulario: {
      totales: {}
    }
  };

  provincias: ProvinciasDto[] = [];
  @Output() cambioDeStep = new EventEmitter<number>();
  moneda: string = '';
  MAX_NUMERIC_18_4 = 99999999999999.9999;

  @ViewChild('selectProvinciaIB') selectProvinciaIB!: ElementRef<HTMLSelectElement>;
  @ViewChild('selectProvinciaIB2') selectProvinciaIB2!: ElementRef<HTMLSelectElement>;

  constructor(private provinciasService: ProvinciasService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.provinciasService.getAll().subscribe(data => this.provincias = data);
    this.validarMontos();
  }

  ngAfterViewInit() { }

  validarMontos(): void {

    // usar solo datos de DatosFacturaCompleta.conceptos 
    const conceptos: conceptosDto[] = this.datosFacturas.conceptos || [];

    const ivaMap = new Map<number, number>(); // clave: %IVA, valor: suma importes

    let totalExento = 0;
    let totalGravado = 0;

    for (const concepto of conceptos) {

      if (!this.moneda)
        this.moneda = concepto.MONE == 'PES' ? '$' : concepto.MONE;

      const porcentajeIVA = concepto.porcen_iva_editable;

      const importe = Number(concepto.impor_editable) || 0;


      // tomar total monto exento de conceptos de aquellos que tengan porcen_iva_editable == null undefined o 0
      if (porcentajeIVA === null || porcentajeIVA === undefined || porcentajeIVA === 0) {
        totalExento += importe;
      } else {
        // tomar total monto gravado de conceptos de aquellos que tengan porcen_iva_editable > 0
        totalGravado += importe;

        // Acumular IVA por tipo
        if (ivaMap.has(porcentajeIVA)) {
          ivaMap.set(porcentajeIVA, ivaMap.get(porcentajeIVA)! + importe);
        } else {
          ivaMap.set(porcentajeIVA, importe);
        }
      }
    }

    // validar que solo existan hasta 4 ivas, si sobrepasa entonces error y volver a listado de conceptos
    if (ivaMap.size > 4) {
      errorMessage(`No esta permitido seleccionar m&aacute;s de 4 tipos de IVAs<br> Por favor verificar`);

      // Requerido para renderizar correctamente el componente actual
      setTimeout(() => {
        this.cambioDeStep.emit(2);
      }, 1000);

      return;
    }

    // Guardar subtotales
    this.datosFacturas.formulario.totales.subtotalExento = totalExento;
    this.datosFacturas.formulario.totales.subtotalGravado = totalGravado;

    let totalIVA = 0;

    const ivaKeys = Array.from(ivaMap.keys());
    ivaKeys
      .sort((a, b) => b - a)
      .slice(0, 4)
      .forEach((porcentaje, index) => {
        const base = ivaMap.get(porcentaje) || 0;
        const importeIVA = Math.round(base * (porcentaje / 100) * 100) / 100;
        totalIVA += importeIVA;

        this.datosFacturas.formulario.totales[`iva${index + 1}`] = {
          porcentaje,
          base: importeIVA,
          importe: importeIVA,
        };
      });

    // Limpiar IVAs no utilizados
    for (let i = ivaKeys.length + 1; i <= 4; i++) {
      this.datosFacturas.formulario.totales[`iva${i}`] = {
        porcentaje: 0,
        base: 0,
        importe: 0,
      };
    }

    this.validarTotal();
  }

  get tieneConceptos(): boolean {
    return !!this.datosFacturas?.conceptos?.length;
  }

  validarTotal(): void {
    const totales = this.datosFacturas.formulario.totales;
    const limpiar = (v: any): number => {
      let n = Number(v);
      if (isNaN(n) || n < 0) return 0;
      if (n > this.MAX_NUMERIC_18_4) return 0;
      return n;
    };

    // Subtotales
    totales.subtotalExento = limpiar(totales.subtotalExento);
    totales.subtotalGravado = limpiar(totales.subtotalGravado);

    const basePercepciones = totales.subtotalExento + totales.subtotalGravado;

    // === Helper para percepciones + impuesto interno ===
    const calcularPorcentajeSobreBase = (clave: string) => {
      const importeKey = `importe${clave}`;
      const porcentajeKey = `porcentaje${clave}`;

      totales[importeKey] = limpiar(totales[importeKey]);
      totales[porcentajeKey] = limpiar(totales[porcentajeKey]);

      if (totales[importeKey] === 0) {
        totales[porcentajeKey] = 0;
        return;
      }

      if (totales[importeKey] > 0 && basePercepciones > 0) {
        totales[porcentajeKey] = Math.round((totales[importeKey] / basePercepciones) * 10000) / 100;
      }

      // Si tiene porcentaje y no importe, recalcular importe
      if (totales[porcentajeKey] > 0 && totales[importeKey] === 0 && basePercepciones > 0) {
        totales[importeKey] = Math.round((basePercepciones * totales[porcentajeKey] / 100) * 100) / 100;
      }
    };

    // === Percepciones
    calcularPorcentajeSobreBase('PercepcionIVA');
    calcularPorcentajeSobreBase('PercepcionIB');
    calcularPorcentajeSobreBase('PercepcionIB2');
    calcularPorcentajeSobreBase('PercepcionIBPlus');
    calcularPorcentajeSobreBase('PercepcionGcias');

    // === Impuestos Internos (se comporta como percepción más)
    calcularPorcentajeSobreBase('ImpuestosInternos');

    // === IVAs
    let totalIVA = 0;
    let totalIVA_Base = 0;

    for (let i = 1; i <= 4; i++) {
      const iva = totales[`iva${i}`] = totales[`iva${i}`] || {};
      iva.base = limpiar(iva.base);
      iva.importe = limpiar(iva.importe);
      iva.porcentaje = limpiar(iva.porcentaje);

      if (iva.base > 0 && iva.importe > 0 && iva.porcentaje === 0) {
        iva.porcentaje = Math.round((iva.importe / iva.base) * 10000) / 100;
      }

      if (iva.base > 0 && iva.porcentaje > 0 && iva.importe === 0) {
        iva.importe = Math.round((iva.base * iva.porcentaje / 100) * 100) / 100;
      }

      totalIVA += iva.importe;
      totalIVA_Base += iva.base;
    }

    // === Total Base y Total General (SEGUN FACTU)

    const total =
      totales.subtotalExento +
      totales.subtotalGravado +
      totales.importeBaseImpuestosInternos +
      totalIVA +
      totales.importePercepcionIVA +
      totales.importePercepcionIB +
      totales.importePercepcionIB2 +
      totales.importePercepcionIBPlus +
      totales.importePercepcionGcias +
      totales.importeImpuestosInternos;

    //totales.totalBase = Math.round(totalBase * 100) / 100;
    totales.totalBase = Math.round(total * 100) / 100;
    totales.total = Math.round(total * 100) / 100;

  }

  public validarFormulario(): boolean {
    const totales = this.datosFacturas.formulario.totales;

    if (totales.importePercepcionIB && !totales.provinciaPercepcionIB) {
      this.mostrarErrorYEnfocar('Debe seleccionar la provincia de la Percepción IB.', this.selectProvinciaIB);
      return false;
    }

    if (totales.importePercepcionIB2 && !totales.provinciaPercepcionIB2) {
      this.mostrarErrorYEnfocar('Debe seleccionar la provincia de la Percepción IB2.', this.selectProvinciaIB2);
      return false;
    }

    return true;
  }

  private mostrarErrorYEnfocar(mensaje: string, elemento: ElementRef) {
    showMatSnackMessage(this.snackBar, mensaje, 5000, 'snackbar-custom-orange');
    elemento.nativeElement.focus();
    elemento.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}
